export const DRAFT = 'Kladde';
